import { isNill as t } from "./index67.js";
function s(e) {
  if (t(e) || e === !1 || Array.isArray(e) && e.length === 0)
    return !0;
  switch (typeof e) {
    case "number":
      return isNaN(e) || e === 0;
    case "string":
      return e.trim() === "";
    case "object":
      return e instanceof Date ? isNaN(e.getTime()) : e instanceof RegExp ? e.source === "(?:)" : !t(e) && Object.keys(e).length === 0;
  }
  return !1;
}
export {
  s as isEmpty
};
